import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Tooltip,
  Paper,
  Grid,
  Grow,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { truncate, prettifyDate } from '../../shared/Helpers';

const styles = theme => ({
  grid: {
    width: 'inherit',
    margin: '0px',
    justifyContent: 'space-between',
    [theme.breakpoints.down(1000)]: {
      justifyContent: 'space-around',
    },
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '250px',
    height: '320px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:hover': {
      transform: 'scale(1.05, 1.05)',
    },
  },
  gridItemImg: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    width: '100%',
    height: 'auto',
  },
  content: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  category: {
    color: '#f44336',
    marginRight: theme.spacing(1),
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  inlineFlex: {
    display: 'flex',
  },
  greyRule: {
    height: '1px',
    backgroundColor: 'lightgray',
    border: 'none',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.3rem',
  },
});

const BlogPostGrid = ({ classes, posts }) => (
  <Grid container spacing={3} className={classes.grid}>
    {posts.map((post, index) => {
      const to = {
        pathname: `/blog/${post.url_slug || post.id}`,
        post,
      };
      return (
        <Link to={to} style={{ textDecoration: 'none' }} key={post.id}>
          <Grow appear in timeout={(400 * (index % 9))} style={{ transformOrigin: '0 0 0' }}>
            <Grid item xs={12} sm={6} md={4}>
              <BlogPostGridItem
                className={classes.gridItem}
                title={post.title}
                author={post.author}
                date={post.post_date}
                dateOverride={post.post_date_text_override}
                excerpt={post.excerpt}
                img={post.header_img}
                category={post.category.name}
              />
            </Grid>
          </Grow>
        </Link>
      );
    })}
  </Grid>
);

BlogPostGrid.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  posts: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};

export default withStyles(styles)(BlogPostGrid);

let BlogPostGridItem = ({
  title,
  date,
  dateOverride,
  excerpt,
  img,
  category,
  classes,
}) => (
  <Paper elevation={2} className={classes.gridItem}>
    <img className={classes.gridItemImg} src={`${img}`} alt={`Header for ${excerpt}`} />
    <div className={classes.content}>
      <Tooltip placement="top-start" title={title}>
        <Typography className={classes.title} variant="h5">{truncate(title, 40)}</Typography>
      </Tooltip>
      <div className={classes.inlineFlex}>
        <Typography className={classes.category}>{category}</Typography>
        <Typography color="textSecondary">{dateOverride ? truncate(dateOverride, 12) : prettifyDate(date)}</Typography>
      </div>
      <hr className={classes.greyRule} />
      <Typography>{truncate(excerpt, 82)}</Typography>
    </div>
  </Paper>
);

BlogPostGridItem.defaultProps = {
  dateOverride: '',
};

BlogPostGridItem.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  dateOverride: PropTypes.string,
  excerpt: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};

BlogPostGridItem = withStyles(styles)(BlogPostGridItem);
